import {CSSProperties} from "react";

const PERA_WALLET_MODAL_STYLES: CSSProperties = {
  position: "absolute",
  maxWidth: " var(--widget-width)",
  width: "100%",
  maxHeight: "var(--widget-height)",
  height: "100%",
  borderRadius: "var(--container-border-radius)",
  backgroundColor: " var(--overlay)"
};

const PERA_SIGN_TXN_MODAL_BODY_STYLES: CSSProperties = {
  top: "unset",
  left: "unset",
  animation: "none",
  width: "100%",
  maxWidth: "unset",
  transform: "unset"
};

const PERA_WALLET_MODAL_BODY_STYLES: CSSProperties = {
  top: "unset",
  margin: "4px",
  padding: "0",
  animation: "none",
  position: "absolute",
  height: "396px",
  width: "calc(100% - 8px)",
  borderRadius: "var(--container-border-radius)"
};

const PERA_WALLET_MODAL_BODY_WRAPPER_STYLES: CSSProperties = {
  position: "absolute",
  bottom: "0",
  height: "396px",
  width: "calc(100% - 8px)",
  overflowY: "auto",
  margin: "4px",
  borderRadius: "var(--container-border-radius)"
};

const PERA_WALLET_MODAL_BODY_HEADER_STYLES: CSSProperties = {
  position: "absolute",
  top: "12px",
  padding: "0 12px",
  zIndex: "3",
  width: "24px",
  marginLeft: "auto"
};

const PERA_WALLET_MODAL_BODY_HEADER_CLOSE_BUTTON_STYLES: CSSProperties = {
  width: "24px",
  height: "24px",
  background: "var(--global-black)"
};

export {
  PERA_WALLET_MODAL_STYLES,
  PERA_WALLET_MODAL_BODY_STYLES,
  PERA_SIGN_TXN_MODAL_BODY_STYLES,
  PERA_WALLET_MODAL_BODY_WRAPPER_STYLES,
  PERA_WALLET_MODAL_BODY_HEADER_STYLES,
  PERA_WALLET_MODAL_BODY_HEADER_CLOSE_BUTTON_STYLES
};
